import React, { useState, useEffect } from "react";
import { toast } from "sonner";
import useVolunteers from "../../../Hooks/Volunteer Api/useVolunteers";

const initialVolunteerData = {
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  password: "",
};


const AddVolunteerModal = ({ isOpen, onClose, Refresh }) => {

   const { registerVolunteerApi } = useVolunteers();

  const [formData, setFormData] = useState(initialVolunteerData);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

 const handleSubmit = async () => {
  if (!formData.firstName || !formData.phoneNumber || !formData.password) {
    toast.error("Please fill required fields");
    return;
  }

  setIsSubmitting(true);

  const payload = {
    ...formData,
    userType: "volunteer", 
  };

  await registerVolunteerApi(payload, () => {
    setFormData(initialVolunteerData);
    Refresh?.();
    onClose();
  });

  setIsSubmitting(false);
};


  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white max-h-[90vh] overflow-y-auto w-full max-w-2xl rounded-xl shadow-lg p-6">
        <h2 className="text-xl font-semibold mb-4">Add New Volunteer</h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
         {Object.keys(initialVolunteerData).map((field) => (
  <div key={field}>
    <label className="block text-sm font-medium capitalize mb-1">
      {field.replace(/([A-Z])/g, " $1")}
    </label>
    <input
      type={field === "password" ? "password" : "text"}
      name={field}
      value={formData[field]}
      onChange={handleChange}
      className="w-full border border-gray-300 px-3 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
    />
  </div>
))}

        </div>

        <div className="mt-6 flex justify-end gap-3">
          <button
            onClick={onClose}
            disabled={isSubmitting}
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={isSubmitting}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            {isSubmitting ? "Saving..." : "Save Volunteer"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddVolunteerModal;
